import { render, staticRenderFns } from "./AcaoPlanoTrabalhoForm.vue?vue&type=template&id=5f53e57d"
import script from "./AcaoPlanoTrabalhoForm.vue?vue&type=script&lang=js"
export * from "./AcaoPlanoTrabalhoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports